import { render, staticRenderFns } from "./component.streaming-message.vue?vue&type=template&id=4ba32014&scoped=true"
import script from "./component.streaming-message.vue?vue&type=script&lang=js"
export * from "./component.streaming-message.vue?vue&type=script&lang=js"
import style0 from "./component.streaming-message.vue?vue&type=style&index=0&id=4ba32014&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ba32014",
  null
  
)

export default component.exports